// «Текст статьи» под пунктом ответа по праву: статья закона целиком из базы Правосвода (GET /api/laws/<id>).
// Загружается только при раскрытии; у пункта из оглавления главы — статья, чей заголовок процитирован.
import { useState } from "react";
import { getJson } from "../api";

type Article = { id: string; label: string; checked: string; act: string; text: string };

// «law:gk1:218» — сама статья; «toc:gk1:14» + цитата «Статья 234. Приобретательная давность» — ст. 234 той же части.
export function articleId(sourceId: string | undefined, quote: string): string {
  if (!sourceId) return "";
  if (sourceId.startsWith("law:")) return sourceId;
  const toc = sourceId.match(/^toc:([a-z0-9]+):/);
  const number = quote.match(/^Статья\s+(\d+(?:\.\d+)*)/);
  return toc && number ? `law:${toc[1]}:${number[1]}` : "";
}

// Что раскрывается: статья кодекса или закона, пункт постановления Правительства («Правила дорожного движения РФ,
// п. 2.7») или таблица из него целиком (размеры наркотических средств).
export function articleSummary(label: string | undefined): string {
  if (!label || /^(ст\.|преамбула)\s/.test(label)) return "Текст статьи";
  return /, п\. [\d.]+$/.test(label) ? "Текст пункта" : "Весь текст";
}

export function ArticleText({ id, label }: { id: string; label?: string }) {
  const [article, setArticle] = useState<Article | null>(null);
  const [error, setError] = useState("");
  function load(open: boolean) {
    if (!open || article || error) return;
    getJson<Article>(`/api/laws/${encodeURIComponent(id)}`).then(setArticle).catch((failure) => setError((failure as Error).message));
  }
  return (
    <details className="assistant-article" onToggle={(event) => load((event.currentTarget as HTMLDetailsElement).open)}>
      <summary>{articleSummary(label)}</summary>
      {error ? <p className="msg-error">{error}</p> : !article ? <p className="msg-hint">Загружаю…</p> : (
        <>
          <blockquote>{article.text}</blockquote>
          <p className="msg-hint">{article.act ? `${article.act}. ` : ""}Сверено {article.checked}.</p>
        </>
      )}
    </details>
  );
}
